import { BaseIncludedProduct, IncludedProduct, PackageIncludedProduct } from '../models/included-product';

/**
 * Map to base included product.
 * @param {object} dto Dto.
 * @returns {BaseIncludedProduct}
 */
function baseIncludedProductFromDto(dto) {
  return new BaseIncludedProduct({
    id: dto.id,
    name: dto.name,
    unitPrice: dto.unit_price,
  });
}

/**
 * Map to package included product.
 * @param {object} dto Dto.
 * @returns {PackageIncludedProduct}
 */
function packageIncludedProductFromDto(dto) {
  return new PackageIncludedProduct({
    ...baseIncludedProductFromDto(dto),
    description: dto.description,
  });
}

/**
 * Map to included product.
 * @param {object} dto Dto.
 * @returns {IncludedProduct}
 */
function fromDto(dto) {
  return new IncludedProduct({
    ...baseIncludedProductFromDto(dto),
    code: dto.code,
    typeId: dto.type_id,
    editDate: dto.edit_date,
  });
}

export const includedProductMapper = {
  fromDto,
  baseIncludedProductFromDto,
  packageIncludedProductFromDto,
};
